import React, { useRef, useState } from "react"
import { Modal } from "react-bootstrap"
import { MdClose } from "react-icons/md"

import FuwFiles from "./FuwFiles"
import FuwDevice from "./FuwDevice"
import FuwTabs from "./FuwTabs"
import FuwLinks from "./FuwLinks"
import FuwEditImage from "./FuwEditImage"
import FuwCamera from "./FuwCamera"
import FuwGallery from "./FuwGallery"
import classes from "./FuwModal.module.scss"

const FuwModal = props => {
  const {
    options,
    accountId,
    imageCategory,
    enableCrop,
    preserveOriginalFile,
    aspectRatio,
    openModal,
    setOpenModal,
    maxNumberOfUploads,
    onUploadComplete
  } = props

  const [files, setFiles] = useState([])
  const [tab, setTab] = useState("device")
  const [selectedFileForEdit, setSelectedFileForEdit] = useState(null)
  const [gallery, setGallery] = useState(null)
  const [hasMore, setHasMore] = useState(true)
  const [skip, setSkip] = useState(0)

  const handleExited = () => {
    setFiles([])
    setTab("device")
    setSelectedFileForEdit(null)
    setGallery(null)
    setSkip(0)
    setHasMore(true)
  }

  const originalFiles = useRef([])

  const maxFilesReached =
    files.length === maxNumberOfUploads

  return (
    <Modal
      show={openModal}
      onHide={() => setOpenModal(true)}
      onExited={handleExited}
      backdrop="static"
      centered
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <MdClose
            size={20}
            className={classes["close"]}
            onClick={() => setOpenModal(false)}
          />
          {
            tab !== "editImage" &&
            <FuwTabs
              options={options}
              tab={tab}
              setTab={setTab}
              maxFilesReached={maxFilesReached}
              maxNumberOfUploads={maxNumberOfUploads}
            />
          }
        </div>
        {
          tab === "device" &&
          <FuwDevice
            setTab={setTab}
            setFiles={setFiles}
            numberOfFiles={files.length}
            originalFiles={originalFiles}
            maxNumberOfUploads={maxNumberOfUploads}
          />
        }
        {
          tab === "link" &&
          <FuwLinks
            setTab={setTab}
            setFiles={setFiles}
            numberOfFiles={files.length}
            originalFiles={originalFiles}
            maxNumberOfUploads={maxNumberOfUploads}
          />
        }
        {
          tab === "camera" &&
          <FuwCamera
            setTab={setTab}
            setFiles={setFiles}
            numberOfFiles={files.length}
            originalFiles={originalFiles}
            maxNumberOfUploads={maxNumberOfUploads}
          />
        }
        {
          tab === "media" &&
          <FuwGallery
            setTab={setTab}
            setFiles={setFiles}
            gallery={gallery}
            setGallery={setGallery}
            skip={skip}
            setSkip={setSkip}
            hasMore={hasMore}
            setHasMore={setHasMore}
            accountId={accountId}
            imageCategory={imageCategory}
            numberOfFiles={files.length}
            originalFiles={originalFiles}
            maxNumberOfUploads={maxNumberOfUploads}
          />
        }
        {
          tab === "editImage" &&
          <FuwEditImage
            files={files}
            setFiles={setFiles}
            setTab={setTab}
            aspectRatio={aspectRatio}
            selectedFileIdForEdit={selectedFileForEdit}
            setSelectedFileIdForEdit={setSelectedFileForEdit}
          />
        }
        {
          tab === "files" &&
          <FuwFiles
            files={files}
            setFiles={setFiles}
            setTab={setTab}
            imageCategory={imageCategory}
            enableCrop={enableCrop}
            preserveOriginalFile={preserveOriginalFile}
            setOpenModal={setOpenModal}
            originalFiles={originalFiles}
            maxFilesReached={maxFilesReached}
            onUploadComplete={onUploadComplete}
            maxNumberOfUploads={maxNumberOfUploads}
            setSelectedFileForEdit={setSelectedFileForEdit}
          />
        }
      </div>
    </Modal>
  )
}

export default FuwModal
